import { Injectable, signal } from '@angular/core';
import { ResetPassword } from './reset-password-step';



@Injectable({ providedIn: 'root' })
export class ResetPasswordStepService {
  readonly steps = ResetPassword;
  currentStep = signal<number>(this.steps.default);

  nextStep() {
    const next = this.currentStep() + 1;
    if (next <= Object.keys(this.steps).length) {
      this.currentStep.set(next);
    }
  }

  prevStep() {
    const prev = this.currentStep() - 1;
    if (prev >= 1) {
      this.currentStep.set(prev);
    }
  }

  isStep(stepKey: keyof typeof ResetPassword): boolean {
    return this.currentStep() === this.steps[stepKey];
  }

  getStepKeyByValue(value: number): keyof typeof this.steps | undefined {
    return (Object.keys(this.steps) as Array<keyof typeof this.steps>)
      .find(key => this.steps[key] === value);
  }
  resetSteps() {
    this.currentStep.set(this.steps.default);
  }
}
